import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: SarinManS
 * id DDBD357B-6E94-483F-9A09-0E2131FA8533
 * name chevron-left-circle-outline
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chevron-left-circle-outline.svg
 * tags
 * - Arrow 
 */
export const ChevronLeftCircleOutlineIcon = createSvgIcon(<><path d="M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M15.4,16.6L10.8,12L15.4,7.4L14,6L8,12L14,18L15.4,16.6Z" /></>, 'ChevronLeftCircleOutlineIcon');
export default ChevronLeftCircleOutlineIcon